/// <reference path="../types/index.d.ts" />

import '../client_forms/sandhollow/style.css';
import FormStructure from './sandhollow/form_structure';

export default FormStructure;